// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2e52d35f","239":"4aa437cf","667":"6da2e780"}[chunkId] + ".chunk.js";
};